import React, { Fragment, useRef,useState,useEffect } from 'react';
import {  useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {Paper, Grid,FormControlLabel,Typography, FormControl, RadioGroup, Radio} from '@material-ui/core';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import errormesages from './errormessages';
import ReactTooltip from 'react-tooltip';
import axios from 'axios';
export default function EirInstallationEquipment(props) {
    const { errors, control } = useFormContext();
    const { validation } = errormesages;
    const classes = useStyle();
    const masterSocketInputRef = useRef();
    const techInstallInputRef=useRef();
    const[showTechInstallation,setShowTechInstallation]=useState(false);
    const[techInstallationFees,setTechInstallationFees]=useState(null);
    const[techRadioVal,setTechRadioVal]=useState('');
    const[customerType,setCustomerType]=useState(null);

    async function  getInstallationType(event){
        if(JSON.parse(localStorage.getItem('eir_be_data')).order.prequal){
            setCustomerType(JSON.parse(localStorage.getItem('eir_be_data')).order.prequal.customerType);
        } 
        if(event.target.value==='yes') {//master socket YES
                let bundleR6Key = JSON.parse(localStorage.getItem('eir_be_data')).order.bundle.plan.r6Key;
                let customerType = ((localStorage.getItem('global_customer_type')==='new') ?'NEW': 'EXISTING');            
                var endpoint = '/store/api/checkout/getInstallationType?customerType=' + customerType + '&bundleR6Key=' + bundleR6Key +'&masterSocket=1';          
                if (customerType === 'EXISTING') {
                    if(sessionStorage.getItem('accountDetails')){
                       let details= JSON.parse(sessionStorage.getItem('accountDetails')) ;
                       endpoint += '&phoneNo=' + details.phoneNumber + '&areaCode=' + details.prefix;
                    }
                }
                if(props.existingProvider){
                    endpoint += '&existingProvider=' + props.existingProvider;
                }  
                /*******/
                try {
                    let res = await axios({
                        method: 'GET',
                        url:endpoint ,
                        cache: false,
                        dataType: 'JSON',
                        processData: false,
                        contentType: false,
                    })
                    if(res.status==200){
                        let order=JSON.parse(localStorage.getItem('eir_be_data')).order;
                        if(res.data==='TECH_INSTALL'){ 
                            props.setHasInstallationFee(true);//to show date and time in installation details
                            //console.log('Order details>>>',order);
                            if((order.bundle.broadband && order.bundle.tv!=null) || (order.bundle.broadband && order.bundle.tv!=null && order.bundle.mobiles.length>0)){
                               // console.log('Order Inside>>>');                               
                                props.setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time. Note that your eir TV (Apple TV) box can be self-installed, it will be sent to you by courier after your broadband service is active.");
                            }else{
                                props.setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time.");
                            }                         
                            props.setTechInstallationValue('TECH_INSTALL');
                            setShowTechInstallation(false);
                        }else if (res.data === 'SELF_INSTALL') {
                            props.setHasInstallationFee(false);//to hide date and time in installation details                          
                            props.setShowTechInstallationMsg(null);
                            props.setTechInstallationValue('SELF_INSTALL');
                            setShowTechInstallation(false);
                        }else{
                            props.setHasInstallationFee(true);//to show date and time in installation details                          
                            if (!localStorage.getItem('has_techInstall_fee')) {
                                //need to select true
                                setTechRadioVal('no');     
                                getInstallationCheck('no')                           
                            }                            
                            props.setTechInstallationValue('TECH_INSTALL_OPTIONAL');
                            getInstalltionFees();
                            setShowTechInstallation(true);
                        }
                    }else{ 
                        let order=JSON.parse(localStorage.getItem('eir_be_data')).order;
                        props.setHasInstallationFee(true);//to show date and time in installation details                          
                        props.setTechInstallationValue('TECH_INSTALL_OPTIONAL'); 
                        getInstalltionFees();
                        setShowTechInstallation(true); 
                    }				
                }
                catch (err) {
                    console.error(err);			
                }
            } else{//master socket NO
                setShowTechInstallation(false);   
                props.setHasInstallationFee(true);//to show date and time in installation details  
                if (localStorage.getItem('has_techInstall_fee')) {
                    localStorage.removeItem('has_techInstall_fee');
                }
                let bundleR6Key = JSON.parse(localStorage.getItem('eir_be_data')).order.bundle.plan.r6Key;
                let customerType = ((localStorage.getItem('global_customer_type')==='new') ?'NEW': 'EXISTING');            
                let endpointURL = '/store/api/checkout/getInstallationType?customerType=' + customerType + '&bundleR6Key=' + bundleR6Key + '&masterSocket=0';
                if (customerType === 'EXISTING') {
                    if(sessionStorage.getItem('accountDetails')){
                       let details= JSON.parse(sessionStorage.getItem('accountDetails')) ;
                       endpointURL += '&phoneNo=' + details.phoneNumber + '&areaCode=' + details.prefix;                      
                    }
                }
                if(props.existingProvider){
                    endpointURL += '&existingProvider=' + props.existingProvider;
                } 
                /*******/
                try {
                    let res = await axios({
                        method: 'GET',
                        url:endpointURL ,
                        cache: false,
                        dataType: 'JSON',
                        processData: false,
                        contentType: false,
                    })
                    if(res.status==200){
                        let order=JSON.parse(localStorage.getItem('eir_be_data')).order;
                        if(res.data==='TECH_INSTALL'){
                            props.setHasInstallationFee(true);//to show date and time in installation details 
                            //console.log('Order details>>>',order);
                            if((order.bundle.broadband && order.bundle.tv!=null)||(order.bundle.broadband && order.bundle.tv!=null && order.bundle.mobiles.length>0)){
                                //console.log('Order Inside>>>');                               
                                props.setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time. Note that your eir TV (Apple TV) box can be self-installed, it will be sent to you by courier after your broadband service is active.");
                            }else{
                                props.setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time.");
                            }
                            props.setTechInstallationValue('TECH_INSTALL');
                            setShowTechInstallation(false);
                        }else if (res.data === 'SELF_INSTALL') {
                            props.setHasInstallationFee(false);//to hide date and time in installation details 
                            props.setShowTechInstallationMsg(null);
                            props.setTechInstallationValue('SELF_INSTALL');
                            setShowTechInstallation(false);
                        }else if (res.data === 'TECH_INSTALL_OPTIONAL') {
                            props.setHasInstallationFee(true);//to show date and time in installation details
                            props.setTechInstallationValue('TECH_INSTALL_OPTIONAL');
                            getInstalltionFees();
                            setShowTechInstallation(true);
                            if (!localStorage.getItem('has_techInstall_fee')) {                                
                                setTechRadioVal('no');
                                getInstallationCheck('no');
                            }                            
                        }
                        else{
                            props.setTechInstallationValue('TECH_INSTALL_OPTIONAL');
                            getInstalltionFees();
                            setShowTechInstallation(true);
                            if (!localStorage.getItem('has_techInstall_fee')) {                               
                                setTechRadioVal('no');
                                getInstallationCheck('no');
                            }
                            props.setHasInstallationFee(true);//to show date and time in installation details                            
                        }
                    }else{ 
                        let order=JSON.parse(localStorage.getItem('eir_be_data')).order;
                        props.setTechInstallationValue('TECH_INSTALL_OPTIONAL'); 
                        getInstalltionFees();
                        setShowTechInstallation(true);  
                        if (!localStorage.getItem('has_techInstall_fee')) {
                            setTechRadioVal('no');
                            getInstallationCheck('no');
                        }                        
                        props.setHasInstallationFee(true);//to show date and time in installation details                          
                    }				
                }
                catch (err) {
                    console.error(err);			
                }
            }
            /*******/
    }
    const getInstalltionFees=()=>{
        if(localStorage.getItem('eir_be_data')){
            let standardFees=JSON.parse(localStorage.getItem('eir_be_data')).order.standardFees;
            let fees=standardFees.filter(st=>st.feeType === 'TECH_INSTALL');
            if(fees.length>0)
                setTechInstallationFees(fees[0].feeAmount);
            else
                setTechInstallationFees('0.00');
        }
    }
    function  getInstallationCheck(val){
        let order=JSON.parse(localStorage.getItem('eir_be_data')).order;
        if(val==='yes') {//master socket YES#
            localStorage.setItem('has_techInstall_fee', true);                                         
            props.setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time.");
        }else{
            if((order.bundle.broadband && order.bundle.tv!=null) || (order.bundle.broadband && order.bundle.tv!=null && order.bundle.mobiles.length>0)){
                props.setShowTechInstallationMsg("In case a technician is required to complete the installation of your service please enter a preferred installation date and time. Note that your eir TV (Apple TV) box can be self-installed, it will be sent to you by courier after your broadband service is active.");                                 
            }else{
                props.setShowTechInstallationMsg("In case a technician is required to complete the installation of your service please enter a preferred installation date and time.");    
            }
            localStorage.removeItem('has_techInstall_fee');
        }
    }
    return (
        <Fragment>
            <Grid item sm={12}>
                <Paper className={classes.contactPaper} variant='elevation' elevation={4}>
                    <Grid container>
                        <Grid item sm={12}>
                            <h2 className={classes.contactTxt}>
                                Your Equipment Details
							</h2>
                        </Grid>
                        <Grid container sm={12}>
                            <Grid item sm={12}>
                                <Grid container>
                                    <Grid item>
                                        <Typography className={classes.personalLabel}>
                                            {props.hasFTTH ? 'Do you have a fibre network terminal in your home?'
                                                : 'Do you have a master phone socket in your household?'
                                            }<span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                                    </Grid>
                                    <Grid item className={classes.questionEquipment}>
                                        <HelpOutlinedIcon
                                            style={{ color: '#892BA0', marginLeft: '1rem' }}
                                            data-tip data-for="masterSocket"
                                        />
                                        <ReactTooltip
                                            id="masterSocket"
                                            place="top"
                                            effect="solid"
                                            arrowColor="white"
                                            className={classes.masterSocket}
                                            getContent={function () {
                                                return (
                                                    <Grid>
                                                        {props.hasFTTH ?
                                                            <Paper variant='elevation' elevation={8}>
                                                                <img
                                                                    src="/.galleries/eir/checkout/fibre-network-terminal.png"
                                                                    className={classes.masterSocketImg}
                                                                />
                                                                <Typography className={classes.masterSocketText}>
                                                                    Identifying that you have an existing fibre network terminal in
                                                                    your house will help us understand the type of installation that you require.
                                                            </Typography>
                                                            </Paper>
                                                            :
                                                            <Paper variant='elevation' elevation={8}>
                                                                <img
                                                                    src="/.galleries/eir/checkout/master-phone-socket.png"
                                                                    className={classes.masterSocketImg}
                                                                />
                                                                <Typography className={classes.masterSocketText}>
                                                                    Identifying that you have an existing master phone socket in
                                                                    your house will help us understand the type of installation that you
                                                                    require.
                                                        </Typography>
                                                            </Paper>
                                                        }
                                                    </Grid>
                                                )
                                            }}
                                        >
                                        </ReactTooltip>
                                    </Grid>
                                </Grid>
                                <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                    <Controller
                                        control={control}
                                        name="masterSocket"
                                        id="masterSocket"
                                        inputRef={masterSocketInputRef}
                                        defaultValue=""
                                        rules={{ required: { value: true, message: validation.masterSocketRequired } }}
                                        error={Boolean(errors.masterSocket)}
                                        as={
                                            <RadioGroup aria-label="masterSocket" name="masterSocket" id='masterSocket'
                                                className={classes.radioButtom}>
                                                <Grid container>
                                                    <Grid item>
                                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControlLabel value="no" control={<Radio />} label="No" className={classes.personalLabel} />
                                                    </Grid>
                                                </Grid>
                                            </RadioGroup>
                                        }
                                        onChange={([event]) => {
                                            getInstallationType(event);
                                            return event.target.value;
                                            }}
                                    />
                                    <ErrorMessage errors={errors} name='masterSocket'>
                                        {({ message }) => <p className={classes.errorMessageGender}>{message}</p>}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                        </Grid>  
                        {showTechInstallation?
                            <Grid container sm={12}>
                            <Grid item sm={12}>
                                <Grid>
                                    <Typography className={classes.personalLabel}>Would you like a technician to install your broadband service?  (This incurs an additional charge of €{techInstallationFees})<span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                                </Grid>
                                <FormControl color="secondary" variant="outlined" fullWidth size="small"  className={classes.dropDownMinWidth}>
						        <Controller
                                    control={control}
                                    name="techInstall"
                                    id="techInstall"
                                    inputRef={techInstallInputRef}
                                    defaultValue={techRadioVal}                                    
                                    rules={{ required: { value: true, message: validation.techInstallRequired } }}
                                    error={Boolean(errors.techInstall)}
                                    as={
                                    <RadioGroup aria-label="techInstall" name="techInstall" id='techInstall'
                                    className={classes.radioButtom}
                                    //value='yes'
                                    >
                                        <Grid container>
                                        <Grid item>
                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" className={classes.personalLabel}/>
                                        </Grid>
                                        <Grid item>
                                        <FormControlLabel value="no" control={<Radio />} label="No" className={classes.personalLabel}/>
                                        </Grid>
                                        </Grid>
                                    </RadioGroup>
                                    }
                                    onChange={([event]) => {
                                        getInstallationCheck(event.target.value);
                                        return event.target.value;
                                    }}
                                />
                                <ErrorMessage errors={errors} name='techInstall'>
                                    {({ message }) => <p className={classes.errorMessageGender}>{message}</p>}
                                </ErrorMessage>			
						        </FormControl>
                            </Grid>
                        </Grid>                         
                        :''}                                           
                    </Grid>
                </Paper>
            </Grid>
        </Fragment>
    );
}